package cz.lhoracek.mapl.ui.screens.rules

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Scaffold
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.dp
import cz.lhoracek.mapl.AppVersion
import cz.lhoracek.mapl.ui.components.MaplTopAppBar
import cz.lhoracek.mapl.ui.theme.MaplTheme
import mapl.composeapp.generated.resources.Res
import mapl.composeapp.generated.resources.home_rules_title
import mapl.composeapp.generated.resources.rules_app_version
import mapl.composeapp.generated.resources.rules_betting_body
import mapl.composeapp.generated.resources.rules_betting_title
import mapl.composeapp.generated.resources.rules_bets_body
import mapl.composeapp.generated.resources.rules_bets_title
import mapl.composeapp.generated.resources.rules_bidding_body
import mapl.composeapp.generated.resources.rules_bidding_title
import mapl.composeapp.generated.resources.rules_intro
import mapl.composeapp.generated.resources.rules_pot_body
import mapl.composeapp.generated.resources.rules_pot_title
import mapl.composeapp.generated.resources.rules_scoring_body
import mapl.composeapp.generated.resources.rules_scoring_title
import mapl.composeapp.generated.resources.rules_setup_body
import mapl.composeapp.generated.resources.rules_setup_title
import mapl.composeapp.generated.resources.rules_summary_title
import mapl.composeapp.generated.resources.rules_tricks_body
import mapl.composeapp.generated.resources.rules_tricks_title
import org.jetbrains.compose.resources.stringResource

@Composable
fun RulesScreen(onBack: () -> Unit) {
    val sections = listOf(
        RuleSection(
            title = stringResource(Res.string.rules_setup_title),
            body = stringResource(Res.string.rules_setup_body),
        ),
        RuleSection(
            title = stringResource(Res.string.rules_bidding_title),
            body = stringResource(Res.string.rules_bidding_body),
        ),
        RuleSection(
            title = stringResource(Res.string.rules_betting_title),
            body = stringResource(Res.string.rules_betting_body),
        ),
        RuleSection(
            title = stringResource(Res.string.rules_tricks_title),
            body = stringResource(Res.string.rules_tricks_body),
        ),
        RuleSection(
            title = stringResource(Res.string.rules_bets_title),
            body = stringResource(Res.string.rules_bets_body),
        ),
        RuleSection(
            title = stringResource(Res.string.rules_pot_title),
            body = stringResource(Res.string.rules_pot_body),
        ),
        RuleSection(
            title = stringResource(Res.string.rules_scoring_title),
            body = stringResource(Res.string.rules_scoring_body),
        ),
    )

    Scaffold(
        topBar = {
            MaplTopAppBar(
                title = stringResource(Res.string.home_rules_title),
                onBack = onBack,
            )
        },
    ) { innerPadding ->
        LazyColumn(
            modifier = Modifier
                .fillMaxSize()
                .padding(innerPadding),
            contentPadding = PaddingValues(16.dp),
            verticalArrangement = Arrangement.spacedBy(12.dp),
        ) {
            item {
                Text(
                    text = stringResource(Res.string.rules_summary_title),
                    style = MaterialTheme.typography.titleMedium,
                )
                Text(
                    text = stringResource(Res.string.rules_intro),
                    style = MaterialTheme.typography.bodyMedium,
                    color = MaterialTheme.colorScheme.onSurfaceVariant,
                    modifier = Modifier.padding(top = 4.dp),
                )
                Text(
                    text = stringResource(Res.string.rules_app_version, AppVersion.name, AppVersion.code),
                    style = MaterialTheme.typography.bodySmall,
                    color = MaterialTheme.colorScheme.onSurfaceVariant,
                    modifier = Modifier.padding(top = 6.dp),
                )
            }

            items(sections) { section ->
                Card(
                    modifier = Modifier.fillMaxWidth(),
                    colors = CardDefaults.cardColors(
                        containerColor = MaterialTheme.colorScheme.surfaceVariant,
                    ),
                ) {
                    Text(
                        text = section.title,
                        style = MaterialTheme.typography.titleSmall,
                        modifier = Modifier
                            .fillMaxWidth()
                            .padding(horizontal = 12.dp, vertical = 10.dp),
                    )
                    Text(
                        text = section.body,
                        style = MaterialTheme.typography.bodySmall,
                        color = MaterialTheme.colorScheme.onSurfaceVariant,
                        modifier = Modifier
                            .fillMaxWidth()
                            .padding(horizontal = 12.dp, vertical = 10.dp),
                    )
                }
            }
        }
    }
}

private data class RuleSection(
    val title: String,
    val body: String,
)

@Preview
@Composable
private fun RulesScreenPreview() {
    MaplTheme {
        RulesScreen(onBack = {})
    }
}
